import { render, staticRenderFns } from "./noticeOldMan.vue?vue&type=template&id=33c1f0a0&scoped=true&"
import script from "./noticeOldMan.vue?vue&type=script&lang=js&"
export * from "./noticeOldMan.vue?vue&type=script&lang=js&"
import style0 from "./noticeOldMan.vue?vue&type=style&index=0&id=33c1f0a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1f0a0",
  null
  
)

export default component.exports